"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SearchComponent = _ref => {
  let {
    searchBoxClassName,
    searchIconClassName,
    onSearch
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: searchBoxClassName
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    onSubmit: e => {
      e.preventDefault();
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: ""
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    controlId: "searchBox"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    placeholder: "Search news and articles",
    onChange: e => onSearch(e)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: searchIconClassName
  }))));
};
var _default = exports.default = SearchComponent;